export default __webpack_public_path__ + "static/media/logo.7500749f.svg";